import { ApiRestService } from './services/api-rest/api-rest.service';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule, HammerModule, Title } from '@angular/platform-browser';
import { HeaderComponent } from './components/header/header.component';
import { HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { PrivacyPolicyDialogComponent } from './components/privacy-policy-dialog/privacy-policy-dialog.component';
import { registerLocaleData } from '@angular/common';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TermAndConditionsDialogComponent } from './components/term-and-conditions-dialog/term-and-conditions-dialog.component';
import localeEsCL from '@angular/common/locales/es-CL';
import { PromotionsCarouselModule } from './components/promotions-carousel/promotions-carousel.module';
import { SpecialOfferDialogComponent } from './components/special-offer-dialog/special-offer-dialog.component';
import { SpecialOfferTermDialogComponent } from './components/special-offer-term-dialog/special-offer-term-dialog.component';
import { GtmConsolidatedDiagnosticComponent } from './components/gtm-consolidated-diagnostic/gtm-consolidated-diagnostic.component';
import { HistoricalBottomSheetComponent } from './components/historical-bottom-sheet/historical-bottom-sheet.component';
import { HistoricalBottomSheetModule } from './components/historical-bottom-sheet/historical-bottom-sheet.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { RouteTrackingService } from './services/route-tracking.service';
import { SharedDirectivesModule } from './shared/shared-directives.module';
registerLocaleData(localeEsCL, 'es-CL');

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    PrivacyPolicyDialogComponent,
    TermAndConditionsDialogComponent,
    SpecialOfferDialogComponent,
    SpecialOfferTermDialogComponent,
    GtmConsolidatedDiagnosticComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    HammerModule,
    HistoricalBottomSheetModule,
    HttpClientModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatCardModule,
    MatChipsModule,
    MatDialogModule,
    MatDividerModule,
    MatGridListModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    PromotionsCarouselModule,
    RouterModule,
    SharedDirectivesModule,
    SweetAlert2Module.forRoot(),
  ],
  providers: [Title, ApiRestService, RouteTrackingService, { provide: LOCALE_ID, useValue: 'es-CL' }],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(
    private router: Router,
    private titleService: Title,
    private routeTrackingService: RouteTrackingService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.titleService.setTitle('Happyland - Portal Promociones');
      }
    });
  }
}
